// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"10a4e4bc3b3ba1c410a9","883":"58503ca36d8f0cc6f092"}[chunkId] + ".js";
};